export class MonitorStartOption {
  MachinePhysicalAddress: string;
  MonitorHandler: string;
  StartOptions: number;

  constructor(macPA: string, monHandler: string, option: number) {
    this.MachinePhysicalAddress = macPA;
    this.MonitorHandler = monHandler;
    this.StartOptions = option;
	}
}
